import Button from '@/components/Button';
import { FiCheckCircle } from '@/components/react-icons/main';
import { FiAlertCircle, FiAlertTriangle, FiClock } from '@/components/react-icons/main/index.esm';
import setQuery from '@/lib/setQuery';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const DetailsLogSectionSidebar = () => {
  const selectedTab = useArgSelector(selectors.query, 'logTab') || 'timeline';
  const activeLogId = useArgSelector(selectors.query, 'logId');
  const errorCount = useSelector((state) => selectors.workflowLogOperationLogErrors(state, activeLogId)?.length) || 0;
  const warningCount = useSelector((state) => selectors.workflowLogOperationLogWarnings(state, activeLogId)?.length) || 0;
  const successCount = useSelector((state) => selectors.workflowLogOperationLogSuccesses(state, activeLogId)?.length) || 0;
  const infoCount = useSelector((state) => selectors.workflowLogOperationLogInfos(state, activeLogId)?.length) || 0;

  const handleTabClick = (tab) => {
    setQuery({ logTab: tab });
  };

  useEffect(() => {
    if (errorCount === 0 && warningCount === 0 && (successCount > 0 || infoCount > 0)) {
      handleTabClick('successes');
    }
  }, [errorCount, warningCount, successCount, infoCount]);

  const getChangesTitle = () => {
    const parts = [];
    if (successCount > 0) {
      parts.push(`${successCount} success`);
    }
    if (infoCount > 0) {
      parts.push(`${infoCount} info`);
    }
    if (parts.length === 0) {
      return 'No work done';
    }
    return parts.join(', ');
  };

  return (
    <div className="sidebar">
      <Button title={'Timeline'} className={`ghost timeline ${selectedTab === 'timeline' ? 'active' : ''}`} icon={FiClock} onClick={() => handleTabClick('timeline')} />
      <Button title={getChangesTitle()} className={`ghost successes ${selectedTab === 'successes' ? 'active' : ''}`} icon={FiCheckCircle} onClick={() => handleTabClick('successes')} />
      <Button title={`${errorCount} Errors`} className={`ghost errors ${selectedTab === 'errors' ? 'active' : ''}`} icon={FiAlertCircle} onClick={() => handleTabClick('errors')} />
      <Button title={`${warningCount} Warnings`} className={`ghost warnings ${selectedTab === 'warnings' ? 'active' : ''}`} icon={FiAlertTriangle} onClick={() => handleTabClick('warnings')} />
    </div>
  );
};

export default DetailsLogSectionSidebar;
